import React, { useCallback, useState } from 'react';
import EditableField from 'src/components/fields/EditableField';
import { InputNumber } from 'antd';

export interface InputEditableFieldProps {
  value: number;
  placeholder?: string;
  className?: string;
  onEditModeChange?: (e: boolean) => void;
  onBlur?: (e: number | undefined) => void;
  min?: number;
  max?: number;
}

const InputNumberEditableField: React.FC<InputEditableFieldProps> = (props: InputEditableFieldProps) => {
  const { value, onBlur, onEditModeChange, className, placeholder, min, max } = props;
  const [innerValue, setInnerValue] = useState<number>(value);
  const submit = useCallback(() => {
    if (value !== innerValue) {
      onBlur && onBlur(innerValue);
    }
  }, [innerValue, onBlur, value]);
  return (
    <EditableField value={value || '-'} onEditModeChange={onEditModeChange} className={className}>
      <InputNumber
        autoFocus
        type={'number'}
        value={innerValue}
        placeholder={placeholder}
        onChange={e => setInnerValue(e || 0)}
        onBlur={() => submit()}
        min={min}
        max={max}
      />
    </EditableField>
  );
};

export default InputNumberEditableField;
